import { render, staticRenderFns } from "./mental-health-category-card.vue?vue&type=template&id=4e1ca011&scoped=true&"
import script from "./mental-health-category-card.vue?vue&type=script&lang=js&"
export * from "./mental-health-category-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1ca011",
  null
  
)

export default component.exports